const mainField = "id";

const dataFieldConfig = [
  {
    id: "name_zh",
    field: "name_zh",
    align: "center",
    disablePadding: false,
    label: "中文名稱",
  },
  {
    id: "name_en",
    field: "name_en",
    align: "center",
    disablePadding: false,
    label: "英文名稱",
  },
  {
    id: "code",
    field: "code",
    align: "center",
    disablePadding: false,
    label: "代碼",
  },
  {
    id: "type_label",
    field: "type_label",
    align: "center",
    disablePadding: false,
    label: "類型",
  },
  {
    id: "unit",
    field: "unit",
    align: "center",
    disablePadding: false,
    label: "單位",
  },
  {
    id: "fitness_type_label",
    field: "fitness_type_label",
    align: "center",
    disablePadding: false,
    label: "體能類型",
  },
  {
    id: "support_ipad_label",
    field: "support_ipad_label",
    align: "center",
    disablePadding: false,
    label: "iPad",
  },
  {
    id: "dashboard_position_label",
    field: "dashboard_position_label",
    align: "center",
    disablePadding: false,
    label: "儀表板順序",
  },
];

const fetchDataConfig = {
  url: "/skillInfo/query",
  defaultSort: "name_zh.asc",
};

const tableActionConfig = [
  {
    type: "link",
    label: "Detail",
    icon: "detail",
    url: "/skill_info/$id",
  },
  {
    type: "confirmDialog",
    label: "Delete",
    icon: "delete",
    url: "/skillInfo/delete/$id",
    dialogConfig: {
      title: "確定要刪除嗎？",
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonAriaLabel: "確定",
      cancelButtonAriaLabel: "取消",
      cancelButtonColor: "#a7a7a7",
      successMsg: "刪除成功",
      failMsg: "刪除失敗",
    },
  },
];

const filterConfig = [
  {
    type: "text",
    label: "按名稱、代碼搜索",
    field: "name_zh,name_en,code",
  },
];

function fetchResultModifier(data) {
  data.forEach((row) => {
    if (row.type === "fit_exam") {
      row.type_label = "體能測試";
    } else if (row.type === "normal") {
      row.type_label = "一般";
    } else {
      row.type_label = row.type || "-";
    }
    row.fitness_type_label = row.fitness_type_zh || row.fitness_type || "-";
    row.support_ipad_label = row.support_ipad ? "是" : "否";
    row.dashboard_position_label =
      row.dashboard_position === 0 || row.dashboard_position
        ? String(row.dashboard_position)
        : "-";
  });
}

const TableConfig = {
  mainField,
  dataFieldConfig,
  fetchDataConfig,
  tableActionConfig,
  filterConfig,
  fetchResultModifier,
};

export default TableConfig;
